import * as Types from '../constants/actionTypes';
const initState = {
  userClients: [],
  userPortals: [],
  addressCollectionList: [],
  allLanguage: [],
  allPackings: [],
  assetsList: [],
  processingList: [],
  pageData:[],
  addressCollectionBySite: {},
  clientPOList: [],
  selectedClientData: {},
  additionalInfoList:[],
  clientadditionalInfoList:[],
  allClients : [],
  isAdding: false
}
export default (state = initState, action) => {
  //console.log(`state in auth is :`,state);
  switch (action.type) {
    case Types.SET_ALL_CLIENTS: {
      return {
        ...state,
        allClients: action.allClients
      }
    }
    case Types.LIST_ALL_CLIENTS:
      return {
        ...state,
        allClients: action.allClients
      }
    case Types.CLIENT_LIST_OF_USER:
      return {
        ...state,
        clientList: action.clientList
      }
    case Types.SELECTED_CLIENT_DATA:
      return {
        ...state,
        selectedClientData: action.selectedClientData
      }
    case Types.ALL_CLIENTS_ERROR: {
      return {
        ...state,
        clientsError: action.clientsError
      }
    }
    case Types.CLIENT_PROCESSING_PARTNERS:
      return {
        ...state,
        clientProcessingSites: action.clientProcessingSites
      }
    case Types.CLIENT_PROCESSING_ERROR:
      return {
        ...state,
        clientProcessPartnerError: action.clientProcessPartnerError
      }
    case Types.SET_ALL_CLIENT_LANGUAGE: {
      return {
        ...state,
        allLanguage: action.allLanguage
      }
    }

    case Types.CLIENT_CULTURES_ADDED_SUCCESS: {
      state.allLanguage.push(action.payload)
      return {
        ...state,
      }
    }
    case Types.CULTURES_DELETED_SUCCESS: {
      const deleteCultIndex = state.allLanguage.findIndex((data) => data.id === action.deleteIndex)
      if (deleteCultIndex >= 0) {
        state.allLanguage.splice(deleteCultIndex, 1);
      }
      return {
        ...state
      }

    }


    case Types.SET_ALL_CLIENT_PACKINGS: {
      return {
        ...state,
        allPackings: action.allPackings
      }
    }
    case Types.SET_ALL_CLIENT_PACKINGS_COUNT: {
      return {
        ...state,
        allPackingsCount: action.allPackings
      }
    }

    case Types.CLIENT_PACKING_ADDED_SUCCESS: {
      state.allPackings.push(action.payload)
      return {
        ...state,
        // addpacking:action.payload
      }
    }
    case Types.CLIENT_PACKING_DELETED_SUCCESS: {
      if(action.deleteIndex){
        const clientPackDeleteIndex = state.allPackings.findIndex(onePack => { return onePack.id===action.deleteIndex })
        if(clientPackDeleteIndex>=0) {
          state.allPackings.splice(clientPackDeleteIndex, 1)
        }
      }
      return {
        ...state
      }
    }

    case Types.CLIENT_PROCESSING_PARTNERS_LIST:
      return {
        ...state,
        processingList: action.payload?.data||[],
        pageData:action.payload?.pageData ||[]
      }
    case Types.CLIENT_PROCESSING_PARTNERS_LIST_COUNT:
        return {
          ...state,
          processingListCount: action.processingListCount
        }
    case Types.CLIENT_PARTNER_ADDED_SUCCESS:
      state.processingList.push(action.payload)
      return {
        ...state
      }
    case Types.CLIENT_PARTNER_DELETED_SUCCESS:
      const deleteIndex = state.processingList.findIndex((oneProcess) => { return oneProcess.id === action.deleteIndex })
      if (deleteIndex >= 0) {
        state.processingList.splice(deleteIndex, 1)
      }
      return {
        ...state
      }
    case Types.CLIENT_ASSETS_LIST:
      return {
        ...state,
        assetsList: action.clientassetsList
      }
    case Types.CLIENT_ASSETS_LIST_COUNT:
      return {
        ...state,
        assetsListCount: action.assetListCount
      }
    case Types.CLIENT_ASSETS_ADDED_SUCCESS:
      state.assetsList.push(action.payload)
      return {
        ...state,
      }
    case Types.CLIENT_ASSETS_DELETED_SUCCESS:
      const clientDeleteAssetIndex = state.assetsList.findIndex((oneAsset) => {return oneAsset.id === action.deleteIndex})
      if(clientDeleteAssetIndex>=0) {
        state.assetsList.splice(clientDeleteAssetIndex, 1)
      }
      return {
        ...state
      }
    /*  client assets without pagination */
    case Types.CLIENT_ALL_ASSETS_LIST:
      return {
        ...state,
        allClientAssets: action.allClientAssets
      }
    case Types.CLIENT_ASSET_ERROR:
      return {
        ...state,
        clientAssetError: action.clientAssetError
      }
    case Types.CLIENT_ADDED_SUCCESS:
      return Object.assign({}, state, { clientId: action.payload, isPending: false, clientError: "" })
    case Types.CLIENT_ADDING:
      return { ...state, isAdding: true }
    case Types.CLIENT_COPY_SUCCESS:
      return { ...state, clientMessage: action.payload.message, isAdding: false, 
        // do not use because add client and add portal was merged in one step
        //clientList: [ ...state.clientList, { id: action.payload.data[0].id, name: action.payload.data[0].name }]
      }
    case Types.CLEAR_CLIENT_MESSAGE:
        return { ...state, clientMessage: "", clientError: "" }
    case Types.CLIENT_DELETED_SUCCESS:
    const newList = state.allClients.filter((client) => client.id !== action.payload )
      return {
        ...state,
        allClients : newList,
        deleteStatus: action.payload
      }
    case Types.CLIENT_UPDATE_SUCCESS:
      return {
        ...state,
        updateStatus: action.payload
      }
    /**Client Address Collections */
    case Types.SET_ADDRESS_COLLECTIONS:
      return {
        ...state,
        addressCollectionList: action.data
      }
    case Types.DELETE_ADDRESS_COLLECTION_SUCCESS:
      const { siteId } = action.payload
      return {
        ...state,
        addressCollectionList: state.addressCollectionList.filter(item => item.siteId !== siteId)
      }
    case Types.GET_COLLECTION_ADDRESS_BY_SITE:
      return {
        ...state,
        addressCollectionBySite: action.siteData
      }
    case Types.ADD_ADDRESS_COLLECTION_SUCCESS:
      state.addressCollectionList.push(action.payload)
      return {
        ...state
      }
    case Types.PORTAL_COLLECTION_ADDRESS_ERROR:
      return {
        ...state,
        addressError: action.addressError
      }
    case Types.UPDATED_COLLECTION_ADDRESS:
      let findExistIndex;
      if (action.updatedCollection) {
        findExistIndex = state.addressCollectionList && state.addressCollectionList.findIndex((oneSite) => { return oneSite.siteId === action.updatedCollection.siteId })
        if (findExistIndex >= 0) {
          state.addressCollectionList[findExistIndex] = action.updatedCollection
        }
      }
      return {
        ...state
      }
    case Types.PROGRAM_COLLECTION_BULK_UPLOAD_DATA:
      let existCollectionAddress = state.addressCollectionList
      if (action.collectionData && action.collectionData.length) {
        existCollectionAddress = [...existCollectionAddress, ...action.collectionData]
      }
      return {
        ...state,
        addressCollectionList: existCollectionAddress
      }

    /* User Clients Information */
    case Types.USER_CLIENTS_ERROR:
      return {
        ...state,
        userClientError: action.userClientError
      }
    case Types.USER_CLIENTS_DATA:
      return {
        ...state,
        userClients: action.userClients
      }
      
    case Types.USER_PORTALS_DATA:
      return {
        ...state,
        userPortals: action.userPortals
      }
    
      
    case Types.DELETED_USER_PORTAL:
      return {
        ...state,
        userPortals: state.userPortals.filter(item => item.id !== action.payload.id)
      }
    case Types.DELETED_USER_CLIENT_INFO:
      state.userClients.splice(action.delIndex, 1);
      return {
        ...state
      }
    case Types.SAVE_CURRENT_PAGE:
      state.currentPage = action.currentPage;
      return {
        ...state
      }
    case Types.CLIENT_TERMS_SUCCESS:
      return {
        ...state,
        clientTermsPrivacy: action.payload
      }
    case Types.ADDED_USER_CLIENT_INFO: {
      state.userClients.push(action.addedUserClientInfo)
      return {
        ...state
      }
    }
    case Types.GET_CLIENT_SERVICES:
      return {
        ...state,
        clientServiceList: action.payload
      }
    case Types.GET_CLIENT_SERVICES_COUNT:
      return {
        ...state,
        clientServiceListCount: action.payload,
        clientPackagingServicesCount: action.packagingServices,
        clientStandardServicesCount: action.standardServices
      }
    case Types.CLIENT_SERVICES_ADDED:
        state.clientServiceList.push(action.payload)
      return {
        ...state,
        addedService:action.payload
      }
    case Types.CLIENT_SERVICES_DELETE_SUCCESS:
      const delServiceIndex = state.clientServiceList.findIndex((oneService)=> {return oneService.id === action.deleteIndex })
      if(delServiceIndex>=0) {
        state.clientServiceList.splice(delServiceIndex, 1)
      }
      return {
        ...state
      }
    case Types.CLIENT_SERVICES_UPDATE_SUCCESS:
      const updateServiceIndex = state.clientServiceList.findIndex((oneClient)=> {return oneClient.id === action.payload.id })
      if(updateServiceIndex>=0) {
        state.clientServiceList[updateServiceIndex] = action.payload
      }
      return {
        ...state,
      }
    case Types.CLIENT_SERVICES_DELETE_ERROR:
      return {
        ...state,
        clientServiceError: action.payload
      }
    case Types.CLIENT_ERROR:
      return {
        ...state,
        clientError: action.payload,
        isAdding: false
      }
    case Types.GET_CLIENT_PO:
      return {
        ...state,
        clientPOList: action.poList
      }
    case Types.GET_CLIENT_PO_COUNT:
      return {
        ...state,
        clientPOListCount: action.poListCount
      }
    case Types.CLIENT_PO_ADD_SUCCESS: {
      state.clientPOList.push(action.poAdded)
      return {
        ...state
      }
    }
    case Types.CLIENT_PO_DELETE_SUCCESS:
      const clientPoDelIndex = state.clientPOList.findIndex((poIndex)=> {return poIndex.id === parseInt(action.delIndex)})
      if(clientPoDelIndex>=0) {
      state.clientPOList.splice(clientPoDelIndex, 1);
      }
      return {
        ...state
      }
    case Types.CLIENT_PO_UPDATE:
      const clientUpdatePoIndex = state.clientPOList.findIndex((oneIndex)=> {return oneIndex.id === action.poUpdatedList.id})
      if(clientUpdatePoIndex>=0) {
        state.clientPOList[clientUpdatePoIndex] = action.poUpdatedList
      }
      return {
        ...state
      }
      case Types.SET_ALL_ADDITIONAL_INFO: {
        return {
          ...state,
          additionalInfoList: action.payload
        }
      }
      case Types.CLIENT_ADDITIONAL_INFO_LIST: {
        return {
          ...state,
          clientadditionalInfoList: action.clientadditionalInfoList
        }
      }
      case Types.CLIENT_ADDITIONAL_INFO_ADDED_SUCCESS:
      state.clientadditionalInfoList.push(action.payload)
      return {
        ...state,
      }
      case Types.CLIENT_ADDITIONAL_INFO_DELETED_SUCCESS:
      const index = state.clientadditionalInfoList.findIndex((res) => {return res.id === action.deleteIndex})
      if(index>=0) {
        state.clientadditionalInfoList.splice(index, 1)
      }
      return {
        ...state
      }
    default:
      return state;
  }
};


